<div class="container-fluid event-list default-block-padding">
  <div class="row">
    <div class="col-12 text-center">
      <h1 [ngClass]="{'color-4': data?.titleColor === 'yellow'}">
        {{ data.title }}
        <div *ngIf="data.description" class="description">
          {{ data.description }}
        </div>
      </h1>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6" *ngFor="let event of data?.events">
      <div class="img-box mb-3">
        <div class="transparent-overlay default-border-radius"></div>
        <!-- Responsive image background for >= 991px, fallback to <img> for < 991px -->
        <div *ngIf="event.image?.url" class="img-bg default-border-radius d-none d-lg-block" [ngStyle]="{'background-image': 'url(' + event.image.url + ')'}"></div>
        <img
          *ngIf="event.image?.url"
          [src]="event.image.url"
          [alt]="event.image?.alternativeText"
          class="img-fluid default-border-radius d-block d-lg-none"
        />
        <div class="info-box">
          <h3>{{ event.title }}</h3>
          <div class="description">{{ event.description }}</div>

          <div class="links">
            <a
              *ngFor="let link of event.links; let i = index"
              [href]="link.url"
              class="btn me-3"
              [ngClass]="{ 'btn-light-blue': i % 2 === 0, 'btn-light': i % 2 !== 0 }"
              target="{{ link?.openInNewTab ? '_blank' : '_self' }}"
              >{{ link?.text }}
              <i
                class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"
              ></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
